import { useState, useEffect, useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";

import { Container, Button, Box } from "@material-ui/core";

import Api from "lib/api/httpRequestHelper";

import FilterCard from "components/_refactor/filter-card";
import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

import UtilsFncs from "utils/UtilsFncs";

import Filters from "./components/filters";
import TableVitrines from "./components/table";
import DetailsModal from "./components/details-modal";

export default function VisualizarVitrines() {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [selectedVitrine, setSelectedVitrine] = useState(null);
  const [showcaseList, setShowcaseList] = useState([]);
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 25,
    totalSize: 0,
  });
  const [filters, setFilters] = useState({
    publicType: null,
    vitrineName: null,
    status: null,
    initialDate: null,
    finalDate: null,
  });

  const isRepresentative =
    JSON.parse(localStorage.getItem("userDetail"))?.UsuarioPerfis?.length ===
      1 &&
    JSON.parse(localStorage.getItem("userDetail"))?.UsuarioPerfis?.[0]
      ?.NomePerfil === "REPRESENTANTE";

  const snackbar = useSnackbar();
  const history = useHistory();

  const handleSearch = async () => {
    setIsLoading(true);

    const params = new URLSearchParams({
      page: pagination.page || 0,
      pageSize: pagination.pageSize || 25,
    });

    if (filters.status && filters.status.value !== "TODOS")
      params.set("status", filters.status.value);
    if (filters.vitrineName) params.set("nome", filters.vitrineName?.trim());
    if (filters.initialDate)
      params.set(
        "dataVigenciaInicio",
        UtilsFncs.ConvertDateFormat(filters?.initialDate, "-", "-")
      );
    if (filters.finalDate)
      params.set(
        "dataVigenciaFim",
        UtilsFncs.ConvertDateFormat(filters?.finalDate, "-", "-")
      );

    for (const p of params) {
      if (!p[1]) params.delete(p[0]);
    }

    try {
      const response = await Api.get(
        isRepresentative
          ? "virtual-showcase-b2b-representative-list"
          : "virtual-showcase-b2b-list",
        "showcaseB2B",
        `?${params.toString()}`,
        true
      );
      const result = response?.Result?.ListaVitrines;
      setPagination((prev) => ({
        ...prev,
        totalSize: response?.Result?.TotalRegistro || 0,
        page: response?.Result?.Pagina + 1,
        pageSize: response?.Result?.TotalPaginas || 25,
        currentPage: response?.Result?.Pagina + 1,
        currentSizePerPage: response?.Result?.TotalPaginas || 25,
      }));

      setShowcaseList(result);
    } catch (error) {
      snackbar.showMessage("Falha ao buscar vitrines. Tente novamente.", {
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = useMemo(
    (page, pageSize) => {
      setPagination((prev) => ({ ...prev, page, pageSize }));
    },
    [pagination.page, pagination.pageSize]
  );

  const handleViewDetails = useCallback(
    async (id) => {
      setLoadingDetails(true);
      setOpenDetailsModal(true);

      try {
        const response = await Api.get(
          "virtual-showcase-b2b-detail",
          "showcaseB2B",
          `?idVitrineVirtualB2b=${id}`,
          true
        );

        setSelectedVitrine(response.Result);
      } catch (error) {
        snackbar.showMessage("Falha ao visualizar vitrine. Tente novamente.", {
          severity: "error",
        });
      } finally {
        setLoadingDetails(false);
      }
    },
    [snackbar]
  );

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <>
      <HeaderClientes section="Lista de vitrines" subsection="Vitrine" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={isLoading}
          searching={isLoading}
          bottonInfo={
            isRepresentative ? (
              <></>
            ) : (
              <Box
                display="flex"
                justifyContent="flex-end"
                width="100%"
                mt="1rem"
              >
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ width: "150px", height: "50px" }}
                  onClick={() => history.push("/admin/criar-vitrine-b2b")}
                >
                  Nova Vitrine
                </Button>
              </Box>
            )
          }
        >
          <Filters
            isLoading={isLoading}
            filters={filters}
            setFilters={setFilters}
          />
        </FilterCard>
        <TableVitrines
          data={showcaseList}
          loading={isLoading}
          totalSize={pagination.totalSize}
          currentPage={pagination.page}
          currentSizePerPage={pagination.pageSize}
          onPageChange={handlePageChange}
          loadingDetails={loadingDetails}
          handleViewDetails={handleViewDetails}
        />
      </Container>
      <DetailsModal
        open={openDetailsModal}
        onClose={() => {
          setOpenDetailsModal(false);
          setSelectedVitrine(null);
        }}
        loadingDetails={loadingDetails}
        showcaseData={selectedVitrine}
      />
    </>
  );
}
